(ns app.front.view.group.admin.condition-due-date-config
  "Admin config section for condition due dates - enables configuring
   default due date calculation for conditions."
  (:require [app.domain.group.model :as group-model]
            [app.domain.target-time.model :as target-time-model]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.target-time-config :as target-time-config]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [core.util.string :as str-util]))

(defn condition-due-date-config
  "Configuration section for condition due dates."
  [{:keys [tr *group-config parent-config target]}]
  (when (and (ff/enabled? :feature-flag.id/condition-due-dates)
             (<sub [::gas/has-feature? :group.feature/condition-due-date]))
    (let [manual-inputs? (or (get parent-config :group.config/condition-due-date-manual-inputs?)
                             (get @*group-config :group.config/condition-due-date-manual-inputs?)
                             false)
          number-value   (get @*group-config :group.config/condition-due-date-value)]
      (cc/form-group
        {:legend-text (tr [:group-admin/condition-due-dates])}
        [:<>
         [:div.config-row
          (cc/checkbox {:id         (str "condition-due-date-manual-inputs-" target)
                        :label-text (tr [:group.config/condition-due-date-manual-inputs?])
                        :checked    manual-inputs?
                        :disabled   (boolean (get parent-config :group.config/condition-due-date-manual-inputs?))
                        :on-change  #(do (swap! *group-config assoc :group.config/condition-due-date-manual-inputs? %)
                                         (when %
                                           (swap! *group-config assoc :group.config/condition-due-date-value nil)
                                           (swap! *group-config assoc :group.config/condition-due-date-unit nil)))})]
         (when-not manual-inputs?
           [:<>
            [:div.config-row.flex.gap-x-4
             [:div
              [ui/number-input {:id            (str "condition-due-date-value-" target)
                                :label-text    (tr [:group-admin/default-condition-due-date])
                                :default-value number-value
                                :min           1
                                :on-change     #(swap! *group-config assoc
                                                       :group.config/condition-due-date-value
                                                       (some-> % futil/tval str-util/blank->nil js/parseInt))}]]
             [target-time-config/target-time-unit-select
              tr
              *group-config
              :group.config/condition-due-date-unit
              (tr [:group-admin/condition-due-date-unit])
              (str "condition-due-date-unit-" target)
              (not number-value)
              true
              target-time-model/target-time-unit-choice-days+years]]
            [:div.config-row
             [ui/help (tr [:group-admin/condition-due-date-help])]]])]))))

(defn valid? [group-config]
  (if (get group-config :group.config/condition-due-date-manual-inputs?)
    true
    (if-let [date-value (:group.config/condition-due-date-value group-config)]
      (or (-> group-config :group.config/group (group-model/has-feature? :group.feature/condition-due-date) not)
          (and (> date-value 0)
               (:group.config/condition-due-date-unit group-config)))
      true)))
